import { useEffect, useState } from 'react';
import Header1 from '../components/Header1';
import { Helmet } from 'react-helmet-async';
import BackgroundAnimation from '../components/BackgroundAnimation';
import { Container } from 'react-bootstrap';
import api, { API_BASE_URL } from '../api';
import LoadingBox from '../components/LoadingBox';

const Fabric = () => {
  const [fabrics, setFabrics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFabrics = async () => {
      try {
        const response = await api.get('/api/fabrics');
        const safeData = response.data.map((fabric) => ({
          ...fabric,
          description: Array.isArray(fabric.description) 
            ? fabric.description 
            : (typeof fabric.description === 'string' ? [fabric.description] : []),
        }));
        setFabrics(safeData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching fabric data:', error);
        setLoading(false);
      }
    };

    fetchFabrics();
  }, []);

  return (
    <div className="w-full overflow-hidden">
      <Header1 />
      <BackgroundAnimation />
      <Container fluid="md" className="py-5">
        <Helmet>
          <title>Fabric</title>
        </Helmet>
        {loading ? (
          <LoadingBox />
        ) : (
          fabrics.map((fabric, index) => {
            const isEven = index % 2 === 0;

            return (
              <section
                key={index}
                className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 border-b border-gray-200 last:border-b-0"
                id={fabric.name}
              >
                <div className="text-left lg:text-left mb-10">
                  <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-12 mt-12 text-customRed transform transition hover:scale-105 inline-block ">
                    {fabric.name}
                  </h1>
                </div>

                <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12">
                  {/* Description Column */}
                  <div
                    className={`lg:w-1/2 w-full text-left ${
                      isEven ? 'lg:order-1' : 'lg:order-2'
                    }`}
                  >
                    <div className="text-gray-700 text-lg mb-8 leading-relaxed space-y-4">
                      {fabric.description?.map((item, idx) => (
                        <div
                          key={idx}
                          className="flex items-center space-x-3 border-l-4 border-customRed pl-4"
                        >
                          <span className="text-customRed text-3xl font-bold leading-none">
                            ▹
                          </span>

                          <p className="m-2">{item}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Image Column */}
                  <div
                    className={`lg:w-1/2 w-full flex justify-left lg:justify-end ${
                      isEven ? 'lg:order-2' : 'lg:order-1'
                    }`}
                  >
                    <div className="relative group">
                      <img
                        src={fabric.image ? (fabric.image.startsWith('http') ? fabric.image : `${API_BASE_URL}/storage/${fabric.image}`) : ''}
                        alt={fabric.name}
                        className="w-full max-w-sm lg:max-w-md object-cover rounded-lg shadow-xl transform transition duration-500 group-hover:scale-105 group-hover:shadow-2xl"
                      />
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-gray-100 opacity-0 group-hover:opacity-20 transition-opacity rounded-lg" />
                    </div>
                  </div>
                </div>
              </section>
            );
          })
        )}
      </Container>
    </div>
  );
};

export default Fabric;
